import React, { useContext, useEffect, useState } from "react";
import { Col, Image, Button } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import LoginImage from "../../assets/landing/imagenlogin.jpg";
import "./login.style.scss";
import getStorageUser from "../../middlewares/GetStorageUser"

// Components Login
import { FormLogin } from "./components/FormLogin/form.view";
import { HeaderLogin } from "./components/HeaderLogin/header.view";
import { useNavigate, useParams } from "react-router-dom";
import apiRolesPermisos from "../../api/Roles/api-roles-permisos";
import { TemplateContext } from "../../utils/template_context";
import {ModalInfoLogin} from './components/ModalInfoLogin'

export const Login = () => {
  const { screen, id } = useParams();
  const navigate = useNavigate();
  const context = useContext(TemplateContext)
  const [visualizar, setVisualizar] = useState<boolean>(true);

  const existToken = async() => {
    try {
      if(localStorage.user ){
        const user = getStorageUser()
        if( user.role_id < 3  ) {
          navigate("/administrador")
        } else {
          navigate("/usuario")
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  // useEffect(() => {
  //   let mounted = true;
  //   if(mounted ){
  //     existToken();
  //   }
  //   return () => {
  //     mounted = true
  //   }
  // }, [])

  return (
    <div className="container-fluid2 p-0 d-flex justify-content-center vh-80">
      <div className="row">
        <div className="d-none d-lg-block col-lg-6">
          <Image
            src={LoginImage}
            alt="Imagen Login"
            width={"90%"}
            preview={false}
          />
        </div>
        <div className="col-12 col-lg-6 container-form-login height-100">
          <HeaderLogin />
          <FormLogin screen={screen} id={id} />
        </div>
        <div className="position-sticky bottom-0" style={{ zIndex: 2 }}>
          <div className="d-flex justify-content-between flex-direction-responsive-buttons">
            <Button type="link" style={{ fontSize: '14px' }} className="button-blanco-radius-detalle container-detalle-card-body-bold" onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/#convocatorias"; }}>
              <span className="container-detalle-card-body-bold font-responsive-regresar" style={{ fontSize: '14px' }}>VER CONVOCATORIAS</span>
            </Button>
          </div>
        </div>
      </div>
      <ModalInfoLogin
        visualizar={visualizar}
        setVisualizar={setVisualizar}
      />
    </div>
  );
};
